<h1 class="text-2xl" mat-dialog-title>{{'modals.titles.' + title | translate }} </h1>
<mat-dialog-content>
    <p>{{'messages.' + message | translate }} </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="text-error" *ngIf="!Data.clearButtonClose" mat-button mat-dialog-close>{{'modals.actions.cancel' |
        translate }}</button>
    <button color="warn" mat-button [mat-dialog-close]="true" cdkFocusInitial>{{'modals.actions.' + okAction |
        translate }}</button>
</mat-dialog-actions>